var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      staticStyle: {
        "min-width": "1500px",
        "flex-grow": "1",
        height: "100%",
        display: "flex",
        "flex-direction": "column"
      }
    },
    [
      !!_vm.upElementBlock
        ? _c(
            "div",
            { staticStyle: { "margin-top": "2px" } },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.upElementBlock.title))
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "150px",
                    "label-position": "left",
                    inline: ""
                  }
                },
                [
                  _vm._l(_vm.upElementBlock.elementNames, function(
                    elementName
                  ) {
                    return _vm._t(elementName)
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      !!_vm.downElementBlock
        ? _c(
            "div",
            {
              staticClass: "section",
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.downElementBlock.title))
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "150px",
                    "label-position": "left",
                    inline: ""
                  }
                },
                [
                  _vm._l(_vm.downElementBlock.elementNames, function(
                    elementName
                  ) {
                    return _vm._t(elementName)
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }